import React from 'react'
import Modal from 'react-modal';
import LocalizedStrings from 'react-localization';
import {LanguageContext} from "./LanguageContext"

import CloseButton from "./CloseButton"

import './Info.scss';
import logo from './img/SW_Logo.png';

Modal.setAppElement('#root')

let strings = new LocalizedStrings({
    en:{
        title:"infinity texts",
        english:"english",
        german:"german",
        language:"language:",
        settings:"settings",
        support:"the project was supported by ",
        collection:" is a collection of infinite and generative poems by ",
        project:"the project explores the technologies and concepts that will form our future interaction with digital systems. some of the ideas of these poems also appear in a printed and modified version in my books “data poetry” (english) and “datenpoesie” (german).",
        moreinfo:"more info:",
        problems:"problems, questions & suggestions?",
        contact:"contact",
        me:"me",
        wantdonate:"if you want to support the creation of more (or even better) projects like this, drop me a few $, €, ¥ etc.: ",
        donate:"donate",
        buy1:"some of the poems also exist as fine art prints or pen plots, please ",
        buy2:" me if you'd like to buy one."
    },
    de: {
        title:"unendlichkeitstexte",
        english:"englisch",
        german:"deutsch",
        language:"sprache:",
        settings:"einstellungen",
        support:"das projekt wurde unterstützt von ",
        collection:" ist eine sammlung unendlicher und generativer gedichte von ",
        project:"das projekt erforscht die technologien und konzepte die unsere zukünftige interaktion mit digitalen system beeinflussen. einige der ideen für die hier versammelten gedichte finden sich in gedruckter und modifizierter form in meinen büchern „data poetry” (englisch) und „datenpoesie” (deutsch).",
        moreinfo:"mehr info:",
        problems:"probleme, fragen & vorschläge?",
        contact:"kontaktieren Sie",
        me:"mich",
        wantdonate:"wenn Sie die entwicklung von mehr projekten (oder sogar besseren) dieser art unterstützen wollen, können Sie mir hier ein paar $, €, ¥ etc. spenden: ",
        donate:"spenden",
        buy1:"manche der gedichte existieren auch als kunstdruck oder stiftplots. bitte ",
        buy2:" mich, wenn Sie ein bild erwerben wollen."
    }
});

class Info extends React.Component {
    constructor(props) {
        super(props)

        this.state = {isOpen: false}
        this.openInfo = this.openInfo.bind(this);
        this.closeInfo = this.closeInfo.bind(this);
        this.onValueChange = this.onValueChange.bind(this);
    }

    openInfo() {
        this.setState({isOpen:true});
    }

    closeInfo() {
        this.setState({isOpen:false});
    }

    onValueChange() {
        this.context.toggleLanguage()
        this.forceUpdate()
    }

    settings(language, toggleLanguage) {
        return <>
            <h1>{strings.settings}</h1>
            <p>{strings.language}</p>
            <label className="container">{strings.english}
                <input type="radio"
                id="en"
                name="language"
                value="en"
                checked={this.context.language === "en"}
                onChange={this.onValueChange}/>
                <span className="checkmark"></span>
            </label>
            <label className="container">{strings.german}
                <input type="radio"
                id="de"
                name="language"
                value="de"
                checked={this.context.language === "de"}
                onChange={this.onValueChange}
                />
                <span className="checkmark"></span>
            </label>
        </>
    }

    donate() {
        return <form action="https://www.paypal.com/donate" method="post" target="_top">
            <input type="hidden" name="business" value="UN7TZX7EXRU2Y" />
            <input type="hidden" name="currency_code" value="EUR" />
            <button type="submit" className="controlButton" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button">{strings.donate}</button>
        </form>
    }

    render() {
        strings.setLanguage(this.context.language)
        return <>
            <button className="controlButton" onClick={this.openInfo}>info</button>
            <LanguageContext.Consumer>
                {({language, toggleLanguage}) => (
                <Modal
                    isOpen={this.state.isOpen}
                    onAfterOpen={this.afterOpenModal}
                    onRequestClose={this.closeInfo}
                    contentLabel="Info"
                    className="Modal"
                    overlayClassName="Overlay"
                    closeTimeoutMS={500}
                >
                     <div className="info">
                        <button className="closeButton" onClick={this.closeInfo}><CloseButton /></button>
                        <h1>{strings.title}</h1>
                        <p><em>{strings.title}</em>{strings.collection}<a href="https://joerg.piringer.net">jörg piringer</a>. {strings.project}</p>
                        <p>{strings.moreinfo}<br /><a href="https://joerg.piringer.net/datapoetry">https://joerg.piringer.net/datapoetry</a></p>
                        <p>{strings.problems}<br /><a href="https://joerg.piringer.net/index.php?href=contact.xml&mtitle=info">{strings.contact}</a> {strings.me}</p>
                        <p>{strings.wantdonate}{this.donate()}</p>
                        <p>{strings.buy1}<a href="https://joerg.piringer.net/index.php?href=contact.xml&mtitle=info">{strings.contact}</a>{strings.buy2}</p>
                        <p>{strings.support}<img src={logo} alt="Logo" width="55px"/></p>
                        {this.settings(language, toggleLanguage)}
                    </div>
                </Modal>
                )}
            </LanguageContext.Consumer>
        </>;
    }
}
Info.contextType = LanguageContext

export default Info
